import { createElement } from 'react';

interface WeaveIconButtonProps extends React.HTMLAttributes<HTMLElement> {
	disabled?: boolean;
	type?: 'button' | 'submit' | 'reset';
	variant?: 'solid' | 'flat' | 'outlined' | 'white' | 'white-outlined';
	iconposition?: 'left' | 'right';
	density?: 'high' | 'medium';
}

export function WeaveIconButton({
	className,
	disabled,
	type,
	variant,
	iconposition,
	density = 'high',
	...rest
}: WeaveIconButtonProps) {
	return createElement('weave-icon-button', {
		className,
		disabled,
		type,
		variant,
		iconposition,
		density,
		...rest,
	});
}
